import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image";
import Parser from 'html-react-parser';

import Layout from 'components/layout';
import SEO from 'components/common/seo';
import { Location } from '@reach/router';

import TagPostList from 'components/blog/tagpostlist'

const TagsTemplate = ({data:{taginfo,posts},pageContext}) => {
    return (
        <Layout>
        <Location>
          {({ location }) => {
            return (
              <SEO
                title={taginfo.data.label}
                description={taginfo.data.description.text}
                pathname={location.pathname}
                image={taginfo.data.image.localFile ? taginfo.data.image.localFile.childImageSharp.fluid.src : null}
              />
            )
          }}
        </Location>  
        <section className="wrapper style1 align-center">
            <div className="inner">
                <div className="index align-left">
                    <section style={{paddingTop:'0px'}}>
                        <div className="content">
                            <header className="tagInfoContainer">
                                {taginfo.data.image.localFile ? (
                                    <div className="tagImage"><Img fluid={taginfo.data.image.localFile.childImageSharp.fluid} /></div>
                                ) : ''}
                                <div className="tagDataInfo">
                                  <h1>{taginfo.data.label}</h1>
                                  {taginfo.data.description.html ? Parser(taginfo.data.description.html) : ''}
                                </div>
                            </header>
                            <hr/>
                            <h4>{posts.totalCount == 1 ? `E' presente 1 solo articolo` : `Presenti ${posts.totalCount} articoli`}</h4>
                            <TagPostList posts={posts.edges} />
                        </div>
                    </section>
                </div>
            </div>
        </section>
        </Layout>
    )

}
export default TagsTemplate

export const pageQuery = graphql`
query TagsBySlug($uid: String!) {
    taginfo: prismicTags(uid: {eq: $uid}) {
      uid
      data {
        label
        description {
            html
            text
        }
        image {
            localFile {
                childImageSharp {
                  fluid(maxWidth: 250, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
        }

      }
    }
    posts: allPrismicBlog(
      sort: {fields: [data___publishdate], order: DESC}, 
      filter: {data: {tags: {elemMatch: {tag: {document: {elemMatch: {uid: {eq: $uid}}}}}}}}
      ) {
      totalCount
      edges {
        node {
          uid
          data {
            title {
              text
            }
            subtitle {
              html
            }
            image {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 150, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            publishdate(formatString: "DD/MM/YYYY")
            tags {
              tag {
                slug
                document {
                  data {
                    label
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
`
